import React, { useRef, useState } from "react";
import ReactCrop from "react-image-crop";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import "react-image-crop/dist/ReactCrop.css";
import useDebounceEffect from "../../../../../hooks/useDebounceEffect";
import { canvasPreview } from "../../../../../utils/canvasPreview";

export default function LogoCropDialog({ open, b64Photo, onConfirm, onCancel }) {
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const [base64, setBase64] = useState("");
  const [completedCrop, setCompletedCrop] = useState();
  const [crop, setCrop] = useState({
    unit: "%",
    x: 5,
    y: 5,
    width: 90,
    height: 90,
  });

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        const b64 = await canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          1,
          0,
        );
        setBase64(b64);
      }
    },
    100,
    [completedCrop],
  );

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onCancel}>
      <DialogTitle>Cortar logo da empresa</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Ajuste a seleção para remover os espaços em branco ao redor da logo. Uma
          logo sem bordas em branco garante melhor exibição no sistema.
        </Typography>
        <ReactCrop
          crop={crop}
          onChange={c => setCrop(c)}
          onComplete={c => setCompletedCrop(c)}
        >
          <img
            ref={imgRef}
            src={b64Photo}
            alt="logo da empresa"
            style={{ maxWidth: "100%" }}
          />
          {!!completedCrop && (
            <canvas
              ref={previewCanvasRef}
              style={{
                display: "none",
                objectFit: "contain",
                width: completedCrop.width,
                height: completedCrop.height,
              }}
            />
          )}
        </ReactCrop>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={() => onConfirm(base64)}
          variant="contained"
          color="primary"
          disabled={!base64}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
